import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';

// Global Component
import HarvestEventEntityNameValue from 'components/HarvestEventEntityNameValue';
import HarvestEventEntityPathNamesValue from 'components/HarvestEventEntityPathNamesValue';
import HarvestEventPickTypeNameValue from 'components/HarvestEventPickTypeNameValue';
import HarvestEventVarietyNameValue from 'components/HarvestEventVarietyNameValue';
import HarvestEventForecastedQuantityValue from 'components/HarvestEventForecastedQuantityValue';
import RoleButtonLink from 'components/RoleButtonLink';

// Global Actions
import { updateQueryString } from 'services/router/actions';

// Global Constants
// @ts-ignore
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Components
import EventTableRowDragSource from './components/EventTableRowDragSource';
import TableActions from '../../../../../../../../../../components/TableActions';

// Styles
import '../../../../styles.scss';
import './styles.scss';

interface Props {
    updateQueryString: Function;
    harvestEventUuid?: number;
}

export class EventTableRow extends React.PureComponent<Props> {
    handleClick = (event: SyntheticEvent<EventTarget>) => {
        event.stopPropagation();
        const { harvestEventUuid } = this.props;

        this.props.updateQueryString({
            seasonalEventModal: true,
            selectedEvent: harvestEventUuid
        });
    };

    render() {
        const { harvestEventUuid } = this.props;
        if (!harvestEventUuid) return null;

        return (
            <EventTableRowDragSource
                harvestEventUuid={harvestEventUuid}
                onClick={this.handleClick}
                className="event-table-row"
            >
                <Table.Cell className="events-table-cell-padding">
                    <HarvestEventEntityPathNamesValue
                        harvestEventUuid={harvestEventUuid}
                    />
                </Table.Cell>
                <Table.Cell className="events-table-cell-padding">
                    <HarvestEventEntityNameValue
                        harvestEventUuid={harvestEventUuid}
                    />
                </Table.Cell>
                <Table.Cell className="events-table-cell-padding">
                    <HarvestEventPickTypeNameValue
                        harvestEventUuid={harvestEventUuid}
                    />
                </Table.Cell>
                <Table.Cell className="events-table-cell-padding">
                    <HarvestEventVarietyNameValue
                        harvestEventUuid={harvestEventUuid}
                    />
                </Table.Cell>
                <Table.Cell className="events-table-cell-padding">
                    <HarvestEventForecastedQuantityValue
                        harvestEventUuid={harvestEventUuid}
                    />
                </Table.Cell>
                <Table.Cell textAlign="right">
                    <TableActions>
                        <RoleButtonLink
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                            params={{
                                seasonalEventModal: true,
                                selectedEvent: harvestEventUuid
                            }}
                        >
                            Schedule
                        </RoleButtonLink>
                        <RoleButtonLink
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                            params={{
                                eventPrintModal: true,
                                selectedEvent: harvestEventUuid
                            }}
                        >
                            Edit Print Properties
                        </RoleButtonLink>
                    </TableActions>
                </Table.Cell>
            </EventTableRowDragSource>
        );
    }
}

export default connect(
    null,
    { updateQueryString }
)(EventTableRow);
